import camelcaseKeys from "camelcase-keys";

import { apiSlice } from "@/lib/rtkquery";
import { ApiResponse, StorageDTO } from "@/types";

type StorageResponse = ApiResponse<StorageDTO>;

const imageApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    createImage: build.mutation<StorageDTO, StorageDTO>({
      query: (data) => {
        return {
          url: "api/v1/storage",
          method: "POST",
          body: data,
        };
      },
      transformResponse: (response: StorageResponse) =>
        camelcaseKeys(response.results),
    }),
  }),
});

export const { useCreateImageMutation } = imageApi;
